let content_blocks = require('../contents');

export function init(){
    
    $('#edit_image_modal .btn.delete').on('click', function(){
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="block_id"]').val();
        $('#'+block_id).remove();
        content_blocks.show_start_block();
        content_blocks.show_block_order();

        modal.modal('hide');

        modal.find('form')[0].reset();
    });

    $('#edit_image_modal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let block = $(button).closest('.block');
        let modal = $(this);
        let alt = block.attr('data-alt')
        let title = block.attr('data-title')
        let url = block.attr('data-url')
        let data_name = block.attr('data-name')
        let translations = [];

        try {

            translations = JSON.parse(block.attr('data-translations'));
            if(typeof translations[window._content_selected_language] != 'undefined'){
                
                if(typeof translations[window._content_selected_language]['title'] != 'undefined'){
                    title = translations[window._content_selected_language]['title'];
                }

                if(typeof translations[window._content_selected_language]['url'] != 'undefined'){
                    url = translations[window._content_selected_language]['url'];
                }

                if(typeof translations[window._content_selected_language]['alt'] != 'undefined'){
                    alt = translations[window._content_selected_language]['alt'];
                }

                if(typeof translations[window._content_selected_language]['data_name'] != 'undefined'){
                    data_name = translations[window._content_selected_language]['data_name'];
                }

            }

        } catch(err){}

        modal.find('[name="block_id"]').val(block.attr('id'));
        modal.find('[name="classes"]').val(block.attr('data-class'));
        modal.find('[name="width"]').val(block.attr('data-width'));
        // modal.find('[name="height"]').val(block.attr('data-height'));
        modal.find('[name="alt"]').val(alt);
        modal.find('[name="title"]').val(title);
        modal.find('[name="url"]').val(url);
        modal.find('[name="blank"]').prop('checked', block.attr('data-blank') == 'true' ? true : false);
        modal.find('[name="nofollow"]').prop('checked', block.attr('data-nofollow') == 'true' ? true : false);
        
        let select_align = modal.find('[name="align"]');
        select_align.find('option[value="'+ block.attr('data-align') +'"]').prop('selected', true);
        select_align.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

        let select_link_type = modal.find('[name="link_type"]');
        if (block.attr('data-link-type') != null || block.attr('data-link-type') != 'undefined') {
            select_link_type.find('option[value="'+ block.attr('data-link-type')).prop('selected', true);
        } else {
            select_link_type.find('option[value="external_link"]').prop('selected', true);
        }
        
        select_link_type.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

        let select_visible = modal.find('[name="visible"]');
        if (block.attr('data-visible') != null || block.attr('data-visible') != 'undefined') {
            select_visible.find('option[value="'+ block.attr('data-visible')).prop('selected', true);
        } else {
            select_visible.find('option[value="visible"]').prop('selected', true);
        }
        
        select_visible.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });
        
        let image = modal.find('input[name="image"]');
        let label = image.next('label');
        label.text(data_name);
    });

    $('#edit_image').on('submit', function (e) {
        e.preventDefault();

        let form = $(this);
        let url = form.find('[name="url"]').val();
        let link_type = form.find('[name="link_type"]').val();

        if (link_type != 'external_link') {
            let url_post = window._routes['microsites.contents.block.check_link_slug'].replace('{microsite}', window.microsite_id).replace('{content}', window.content_id);
    
            let form_data = new FormData();
            form_data.append('link_type', link_type);
            form_data.append('slug', url);
    
            window.forms.post(url_post, form_data, true, true)
                .then((response) => {
                    if (response.data == true) {
                        save_data_atributes(form);
                    } else {
                        window.messages.error(__('No existe el slug indicado'));
                    }
                })
                .catch((error) => {
                    console.log('ERROR', error);
                })
                .finally(() => {
                    window.blockui.release();
                });
        } else {
            save_data_atributes(form);
        }
    });

    $('.block[data-type="image"]').each(function() {
        content_blocks.create_visible_button_blocks($(this));
    })
}

function update_content_image(form_data, block) {
    let url = window._routes['microsites.contents.media'].replace('{microsite}', window.microsite_id).replace('{content}', window.content_id);

    form_data.append('type', block.attr('data-type'));
    window.forms.post(url, form_data, true, true)
        .then((response) => {

            if (response.data != null) {
                block.attr('data-src', response.data.src);
                block.attr('data-thumb-src', response.data.thumb_src);
                block.attr('data-name', response.data.name);
                // block.attr('data-height', form_data.get('height'));
                block.attr('data-media-id',  response.data.media_id);
                block.find('img').attr('src', response.data.thumb_src);

                if(window._content_languages.length > 1){
                    translations = JSON.parse(block.attr('data-translations'));

                    translations[window._content_selected_language]['src'] = response.data.src;
                    translations[window._content_selected_language]['thumb_src'] = response.data.thumb_src;
                    translations[window._content_selected_language]['media_id'] = response.data.media_id;
                    translations[window._content_selected_language]['data_name'] = response.data.name;
                    
                    block.attr('data-translations', JSON.stringify(translations));
                }
            }
                            
        })
        .catch((error) => {
            console.log('ERROR', error);
        })
        .finally(() => {
            window.blockui.release();
        });
}

function save_data_atributes(form) {

    let block = $('#'+ form.find('[name="block_id"]').val());

    let alt = form.find('[name="alt"]').val();
    let title = form.find('[name="title"]').val();
    let url = form.find('[name="url"]').val();
    let link_type = form.find('[name="link_type"]').val();
    // let src = form.find('[name="src"]').val();
    // let thumb_src = form.find('[name="thumb_src"]').val();

    // let image = form.find('input[name="image"]');
    // let label = image.next('label');
    // let data_name = label.val();

    if (link_type == 'external_link' && url != '') {
        //url ha de empezar por http:// o https://
        const patronURL = /^(https?:\/\/)/;
        if (!patronURL.test(url)) {
            url = 'https://'+url;
        }
    }

    let translations = [];
    if(window._content_languages.length > 1){

        try {
            translations = JSON.parse(block.attr('data-translations'));
            if (translations.length == 0) {
                translations = {}
            }
        } catch(err){
            translations = [];
        }

        // preparo traducciones que no existan

        for(let _language of window._content_languages){
            if(typeof translations[_language] == 'undefined'){
                translations[_language] = { 'title': '', 'alt': '', 'url': '', 'src': '' , 'thumb_src': '', 'data_name': '' };
            }
        }

        // guardo tranduccion actual 

        translations[window._content_selected_language]['title'] = title;
        translations[window._content_selected_language]['alt'] = alt;
        translations[window._content_selected_language]['url'] = url;
        // translations[window._content_selected_language]['src'] = block.attr('data-src');
        // translations[window._content_selected_language]['thumb_src'] = block.attr('data-thumb-src');
        // translations[window._content_selected_language]['data_name'] = data_name;

        // si es idioma base

        if(window._content_selected_language == window._locale){

            block.attr('data-title', title);
            block.attr('data-alt', alt);
            block.attr('data-url', url);
            // block.attr('data-src', src);
            // block.attr('data-thumb-src', thumb_src);
            // block.attr('data-name', data_name);

            // actualizamos traducciones vacias

            for(let _language of window._content_languages){
                if(_language != window._locale){
                    if(translations[_language]['title'] == ''){
                        translations[_language]['title'] = title;
                    }
                    if(translations[_language]['alt'] == ''){
                        translations[_language]['alt'] = alt;
                    }
                    if(translations[_language]['url'] == ''){
                        translations[_language]['url'] = url;
                    }
                    if(translations[_language]['src'] == '' || typeof translations[_language]['src'] == 'undefined'){
                        translations[_language]['src'] = block.attr('data-src');
                    }
                    if(translations[_language]['thumb_src'] == '' || typeof translations[_language]['thumb_src'] == 'undefined'){
                        translations[_language]['thumb_src'] = block.attr('data-thumb-src');
                    }
                    if(translations[_language]['data_name'] == '' || typeof translations[_language]['data_name'] == 'undefined'){
                        translations[_language]['data_name'] = block.attr('data-name');
                    }
                }
            }

        }

        if (link_type != 'external_link' || block.attr('data-link-type') != link_type) {
            for(let _language of window._content_languages){
                translations[_language]['url'] = url;
            }
        }

    } else {
        block.attr('data-alt', alt);
        block.attr('data-title', title);
        block.attr('data-url', url);
        // block.attr('data-src', src);
        // block.attr('data-thumb-src', thumb_src);
        // block.attr('data-name', data_name);
    }

    block.attr('data-class', form.find('[name="classes"]').val());
    block.attr('data-visible', form.find('[name="visible"]').val());
    block.attr('data-width', form.find('[name="width"]').val());
    // block.attr('data-height', form.find('[name="height"]').val());
    block.attr('data-link-type', link_type);
    block.attr('data-align', form.find('[name="align"]').val());
    block.attr('data-blank', form.find('[name="blank"]').prop('checked'));
    block.attr('data-nofollow', form.find('[name="nofollow"]').prop('checked'));
    block.attr('data-translations', JSON.stringify(translations));
    
    let modal = form.closest('.modal');
    modal.modal('hide');
    
    let form_data = new FormData(form[0]);
    
    if (form_data.get('url') != '') {
        let url_info = block.find('[name="url_info"]');
        url_info.html('<i class="fa fa-link"></i>');
        url_info.removeClass('d-none');
    } else {
        let url_info = block.find('[name="url_info"]');
        url_info.html('');
        url_info.addClass('d-none');
    }
    let img = block.find('.card-body img');
    let img_col = img.closest('.col');
    img_col.removeClass();
    img_col.addClass(['col', 'd-flex','justify-content-'+form_data.get('align')]);
    
    if (form_data.get('image').name != '') {
        update_content_image(form_data, block);
    }
    content_blocks.change_visible_button_blocks(block);

    form[0].reset();
}